import { Point } from "../../../engine/space/bounds";

export type AIProperties = {
  spawnLocation: Point;
  traitProperties: Record<string, any>;
  words?: string[];
  timid: boolean;
};

const DEFAULT_POINT = { x: -1, y: -1 };

export const makeDefaultAIProps = (): AIProperties => ({
  spawnLocation: DEFAULT_POINT,
  traitProperties: {},
  words: [],
  timid: false,
});
